import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { switchFitToScreen, Platforms } from '../../actions/toolbar'
import { changeMonitor } from '../../actions/webrtcConnection'
import { ALL_MONITORS } from '../../logic/selectActiveMonitor'
import ToolbarButton from './ToolbarButton'


class ViewDropdownComponent extends React.Component {

  onFitToScreen = (viewMode) => {
    this.props.switchFitToScreenAction(viewMode)
  }

  onSelectMonitor = (monitorId) => {
    this.props.changeMonitorAction(monitorId)
  }

  buildViewMenu = () => {
    const { fitToScreen, monitors, platform, activeMonitorId } = this.props
    const items = [
      {
        text: this.context.t('tb-fit-to-screen'),
        checked: fitToScreen,
        onChange: () => this.onFitToScreen(true),
      },
      {
        text: this.context.t('tb-actual-size'),
        checked: !fitToScreen,
        onChange: () => this.onFitToScreen(false),
      },
    ]
    if (platform !== Platforms.IOS) {
      items.push({ divider: true })
      if (monitors.length === 1) {
        items.push({
          text: this.context.t('tb-monitor-primary', { id: (parseInt(monitors[0].id, 10) + 1) }),
          checked: true,
          onChange: () => this.onSelectMonitor('primary'),
        })
      } else {
        items.push({
          text: this.context.t('tb-all-monitors'),
          checked: (this.props.activeMonitorId === ALL_MONITORS),
          onChange: () => this.onSelectMonitor(ALL_MONITORS),
        })
        items.push(...monitors.map((monitor) => ({
          text: monitor.isPrimary
            ? this.context.t('tb-monitor-primary', { id: (parseInt(monitor.id, 10) + 1) })
            : this.context.t('tb-monitor', { id: (parseInt(monitor.id, 10) + 1) }),
          checked: activeMonitorId === monitor.id,
          onChange: () => this.onSelectMonitor(monitor.id)
        })))
      }
    }

    return items.map((item, index) => {
      if (item.divider) {
        return <div key={index} className='menuDivider' />
      }
      return (
        <label key={index} className='menuItem'>
          <input className='menuRadio'
            type='radio'
            checked={item.checked}
            onChange={item.onChange}
          />
          <span className={'tbRadio'}></span>
          {item.text}
        </label>
      )
    })
  }

  render () {
    return (
      <div className='tbArea'>
        <div className='tbDivider' />
        <ToolbarButton
          className='tbMonitors'
          dropdownMenu={this.buildViewMenu()}
          disabled={this.props.videoNotAvailable}
        />
      </div>
    )
  }
}

ViewDropdownComponent.contextTypes = {
  t: PropTypes.func.isRequired
}

ViewDropdownComponent.propTypes = {
  switchFitToScreenAction: PropTypes.func.isRequired,
  changeMonitorAction: PropTypes.func.isRequired,
  monitors: PropTypes.array.isRequired,
  activeMonitorId: PropTypes.string.isRequired,
  fitToScreen: PropTypes.bool.isRequired,
  videoNotAvailable: PropTypes.bool.isRequired,
  platform: PropTypes.string.isRequired,
}


export function mapStateToProps (state) {
  return {
    fitToScreen: state.toolbar.fitToScreen,
    monitors: state.toolbar.monitors,
    activeMonitorId: state.toolbar.activeMonitorId,
    platform: Object.values(Platforms).includes(state.signaling.agentDetails.platformType)
      ? state.signaling.agentDetails.platformType
      : 'windows',
  }
}

function mapDispatchToProps (dispatch) {
  return {
    switchFitToScreenAction: (payload) => {
      dispatch(switchFitToScreen(payload))
    },
    changeMonitorAction: (payload) => {
      dispatch(changeMonitor(payload))
    },
  }
}

export const View = connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewDropdownComponent)
